// Privacy Policy - Estonian version

export const privacyContentET = {
  sections: [
    { id: 'general', title: '1. Üldsätted' },
    { id: 'data', title: '2. Milliseid andmeid me töötleme' },
    { id: 'purposes', title: '3. Eesmärgid ja õiguslikud alused' },
    { id: 'cookies', title: '4. Küpsised ja analüütika' },
    { id: 'ai-services', title: '5. AI ja pilveteenused' },
    { id: 'transfer', title: '6. Andmete edastamine ja salvestamine' },
    { id: 'rights', title: '7. Andmesubjektide õigused' },
    { id: 'security', title: '8. Turvalisus' },
    { id: 'contacts', title: '9. Kontaktandmed' }
  ],
  
  general: {
    title: '1. Üldsätted',
    content: `Käesolev Poliitika kirjeldab, kuidas Polyus Plus OÜ (edaspidi "Ettevõte") töötleb isikuandmeid vastavalt Määrusele (EL) 2016/679 (GDPR) ja Eesti Isikuandmete kaitse seadusele.

Ettevõte tegutseb:

• **Andmete vastutava töötlejana** (veebisaidi ja turunduse käitamisel)
• **Andmete volitatud töötlejana** (teenuste osutamisel klientidele lepingute ja DPA alusel)`
  },
  
  data: {
    title: '2. Milliseid andmeid me töötleme',
    categories: [
      {
        name: 'Isikuandmed',
        icon: 'Eye',
        items: ['Nimi, ametinimetus', 'Kontaktandmed (e-post, telefon)', 'Vormide ja kirjavahetuse andmed']
      },
      {
        name: 'Ettevõtte andmed (B2B)',
        icon: 'Database',
        items: ['Ettevõtte nimi', 'Registrikood', 'Juriidiline aadress']
      },
      {
        name: 'Tehniline info',
        icon: 'Globe',
        items: ['IP-aadress', 'Küpsised ja identifikaatorid', 'Analüütika andmed']
      },
      {
        name: 'Tähtis',
        icon: 'AlertCircle',
        items: ['Me EI kogu delikaatseid isikuandmeid (rassiline päritolu, religioon, tervis)']
      }
    ]
  },
  
  purposes: {
    title: '3. Eesmärgid ja õiguslikud alused',
    intro: 'Töötlemine toimub järgmistel eesmärkidel:',
    bases: [
      {
        title: 'Lepingu täitmine',
        legal: 'Art. 6(1)(b) GDPR',
        description: 'Kommunikatsioon, arveldamine, teenuste osutamine',
        color: 'blue'
      },
      {
        title: 'Turundus',
        legal: 'Art. 6(1)(a) GDPR',
        description: 'Teie nõusolekul (saab igal ajal tagasi võtta)',
        color: 'green'
      },
      {
        title: 'Analüütika ja veebisaidi täiustamine',
        legal: 'Art. 6(1)(f) GDPR',
        description: 'Ettevõtte õigustatud huvi',
        color: 'cyan'
      },
      {
        title: 'Õiguslikud kohustused',
        legal: 'Art. 6(1)(c) GDPR',
        description: 'Maksu- ja raamatupidamisseadused',
        color: 'yellow'
      }
    ]
  },
  
  cookies: {
    title: '4. Küpsised ja analüütika',
    intro: 'Veebisait kasutab küpsiseid ja analüütikateenuseid kasutajakogemuse parandamiseks ja veebisaidi kasutamise mõistmiseks.',
    services: [
      { name: 'Google Analytics 4', description: 'Liikluse ja käitumise analüüs' },
      { name: 'Meta Pixel (Facebook)', description: 'Reklaam ja reamarketing' },
      { name: 'Hotjar', description: 'Soojuskaardid ja UX analüüs' }
    ],
    note: 'Küpsiste sätteid saate hallata oma brauseris või meie sätetes.',
    linkText: 'Küpsiste poliitika'
  },
  
  aiServices: {
    title: '5. AI ja pilveteenused',
    intro: 'Teenuste osutamiseks kasutab Polyus Plus OÜ kaasaegseid AI-platvorme ja pilveteenuseid:',
    platforms: [
      'OpenAI (ChatGPT, DALL-E)',
      'Google Cloud AI',
      'Microsoft Azure',
      'Notion, Airtable'
    ],
    transferNote: 'Andmete edastamisel väljaspool EL-i rakendatakse kaitset **ELi standardsete lepingutingimuste (SCC)** ja Euroopa Komisjoni heakskiidetud muude mehhanismide kaudu.'
  },
  
  transfer: {
    title: '6. Andmete edastamine ja salvestamine',
    intro: 'Andmeid võib edastada ainult:',
    recipients: [
      {
        title: 'Polyus Plus OÜ töötajatele ja töövõtjatele',
        description: 'Allkirjastatud konfidentsiaalsuslepingutega'
      },
      {
        title: 'Hosting-, pilve- ja analüütikateenuste pakkujatele',
        description: 'AWS, Google Cloud, Vercel jt (DPA-ga)'
      },
      {
        title: 'Riigiasutustele',
        description: 'Ainult seaduslike nõuete korral (kohus, maksuamet)'
      }
    ],
    retention: {
      title: 'Säilitamisperiood',
      period: 'Kuni 5 aastat',
      note: 'pärast lepingu lõppu, kui seadus ei nõua teisiti (nt maksu- või raamatupidamisseadused — 7 aastat).'
    }
  },
  
  rights: {
    title: '7. Andmesubjektide õigused',
    intro: 'Vastavalt GDPR-ile on teil järgmised õigused:',
    list: [
      { title: 'Juurdepääsuõigus', description: 'Saada oma isikuandmete koopia' },
      { title: 'Parandamiseõigus', description: 'Parandada ebakorrektseid andmeid' },
      { title: 'Kustutamiseõigus', description: '"Õigus olla unustatud" (teatud tingimustel)' },
      { title: 'Piiramiseõigus', description: 'Piirata oma andmete töötlemist' },
      { title: 'Andmeteülekandeõigus', description: 'Saada andmed struktureeritud vormingus' },
      { title: 'Vastuväiteõigus', description: 'Võtta tagasi nõusolek töötlemiseks' }
    ],
    exercise: {
      title: 'Kuidas oma õigusi kasutada?',
      instruction: 'Saatke taotlus aadressile info@polyusplus.com. Vastame 30 päeva jooksul.',
      complaint: 'Teil on õigus esitada kaebus järelevalveasutusele: **Andmekaitse Inspektsioon** (Eesti andmekaitseorgan) — aki.ee'
    }
  },
  
  security: {
    title: '8. Turvalisus',
    intro: 'Ettevõte rakendab kaasaegseid tehnilisi ja organisatsioonilisi meetmeid teie isikuandmete kaitsmiseks volitamata juurdepääsu, lekke, muutmise või hävitamise eest.',
    measures: [
      { title: 'Krüpteerimine', description: 'SSL/TLS andmeedastuseks', icon: 'Lock' },
      { title: 'Juurdepääsu kontroll', description: 'Mitmefaktoriline autentimine', icon: 'Shield' },
      { title: 'Turvalised serverid', description: 'AWS, Google Cloud DPA-ga', icon: 'Database' }
    ],
    breach: {
      title: 'Rikkumisest teavitamine',
      text: 'Isikuandmete rikkumise korral teavitame järelevalveasutust 72 tunni jooksul ja teid isiklikult, kui rikkumine kujutab suurt riski teie õigustele ja vabadustele.'
    }
  },
  
  contacts: {
    title: '9. Kontaktandmed',
    intro: 'Isikuandmete töötlemise küsimuste või oma õiguste kasutamiseks võtke meiega ühendust:',
    company: 'Polyus Plus OÜ',
    regNumber: '14890902',
    address: 'Uuslinna 11, Tallinn 11415, Estonia',
    email: 'info@polyusplus.com'
  },
  
  gdprNotice: 'Käesolev Poliitika vastab Määruse (EL) 2016/679 (GDPR) ja Eesti Isikuandmete kaitse seaduse nõuetele. Teie andmed on kaitstud kõrgeim Euroopa tasemel.'
};
